export default __webpack_public_path__ + "static/media/arequipa-colca_canyon_river_sunrise.0a04d36a.jpg";